type DateTimeInput = string | number | Date | null | undefined

const KST_TIME_ZONE = 'Asia/Seoul'
const ISO_WITHOUT_TIMEZONE_RE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/

const dateTimeFormatter = new Intl.DateTimeFormat('ko-KR', {
  timeZone: KST_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
})

const dateFormatter = new Intl.DateTimeFormat('ko-KR', {
  timeZone: KST_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const timeFormatter = new Intl.DateTimeFormat('ko-KR', {
  timeZone: KST_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
})

function normalizeDateTimeInput(value: DateTimeInput): DateTimeInput {
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  if (!ISO_WITHOUT_TIMEZONE_RE.test(trimmed)) return value
  return `${trimmed.replace(' ', 'T')}Z`
}

function toDate(value: DateTimeInput): Date | null {
  if (value == null || value === '') return null
  const normalized = normalizeDateTimeInput(value)
  if (normalized == null || normalized === '') return null
  const date = normalized instanceof Date ? normalized : new Date(normalized)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatKstDateTime(value: DateTimeInput, fallback = '-'): string {
  const date = toDate(value)
  return date ? dateTimeFormatter.format(date) : fallback
}

export function formatKstDate(value: DateTimeInput, fallback = '-'): string {
  const date = toDate(value)
  return date ? dateFormatter.format(date) : fallback
}

export function formatKstTime(value: DateTimeInput, fallback = '-'): string {
  const date = toDate(value)
  return date ? timeFormatter.format(date) : fallback
}
